import React from 'react';
import Logo from './Logo';
import Nav from './Nav';
import { FiX } from 'react-icons/fi';

const MobilePopupMenu = ({ content, showMobileMenu, toggleMobileMenu }) => {
  return (
    <div className={`mobile-popup-menu-wrapper ${showMobileMenu ? 'active' : ''}`} onClick={toggleMobileMenu}>
      <div className="mobile-popup-menu-content" onClick={toggleMobileMenu}>
        <div className="mobile-popup-menu-header">
          <Logo image="/images/nav_footer/Atlantic_labs_long.svg" image2="/images/nav_footer/Atlantic_labs_long.svg" />
          <div
            className="close-button"
            onClick={(button) => {
              toggleMobileMenu();
              button.stopPropagation();
            }}
          >
            <FiX />
          </div>
        </div>
        <Nav content={content} toggleMobileMenu={toggleMobileMenu} />
        <div className="contact-us-mobile-wrapper">
          <a href="tel:+1214550988" className="contact-us-mobile">
            <div className="content">
              <p className="assist-text">We can assist you:</p>
              <div className="phone-group">
                <img className="phone-decor-img" src="/images/nav_footer/dropdown-menu-call-bubble.svg" />
                <p className="phone-number"> (214) 550-9888 </p>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};
export default MobilePopupMenu;

// CSS Structure
/*
.mobile-popup-menu{
  .mobile-popup-menu-header{
    .logo{
      .logo-img{
      }
    }
    .close-mobile-popup-menu{
      .close-button{
      }
    }
  }
  
              .main-menu-nav {
              .main-menu-nav-list {
                .main-menu-list-item {
                  .main-menu-link {
                  }
                  &.has-dropdown {
                    .main-menu-link {
                    }
                  }
                }
              }
              .submenu-wrapper {
                .container {
                  .submenu-title-group {
                    .submenu-title {
                    }
                  }
                  .submenu-list {
                    .submenu-item {
                      .submenu-link {
                      }
                      &.btn-wrapper {
                        &.btn-default {
                        }
                      }
                    }
                  }
                  .contact-us-wrapper {
                    .contact-us-link {
                      .contact-us-content {
                        .assist-text {
                        }
                        .phone-img-wrapper {
                        }
                        .phone-icon-img {
                        }
                        .contact-us-rep-img {
                        }
                      }
                      .contact-us-img-bg {
                      }
                    }
                  }
                }
              }
            }

  .contact-us-mobile-wrapper{
    .contact-us-mobile{
      .content{
        .assist-text{
        }
        .phone-group{
          .phone-decor-img{
          }
          .phone-number{
          }
        }
      }
    }
  }
  &.active{

  }
}
*/
